import React from 'react';

const DataStorage = () => {
  return (
    <div className="prose prose-gray max-w-none">
      <p className="text-gray-600 leading-relaxed">
        We implement robust security measures to protect your data:
      </p>
      <ul className="list-disc pl-6 mt-4 space-y-2 text-gray-600">
        <li>End-to-end encryption for sensitive information</li>
        <li>Regular security audits and updates</li>
        <li>Secure data centers with physical and digital protection</li>
        <li>Limited access to personal data by authorized personnel only</li>
      </ul>
    </div>
  );
};

export default DataStorage;